module.exports = __webpack_public_path__ + "static/media/alerts_icon_dark.0be68ca3.png";